import React from 'react';
import PropTypes from 'prop-types';
import './button.css';

const Button = props => {
  return (
    <button
      className={`btn ${props.classList !== undefined ? props.classList : ''}`}
      onClick={props.onClick}
    >
      {props.textButton}
    </button>
  );
};

Button.propTypes = {
  textButton: PropTypes.string.isRequired,
  classList: PropTypes.string,
  onClick: PropTypes.func
};

export default Button;
